import { Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { Inject } from '@angular/core';
import { CoreService } from '../../services/core-service.service';


@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.css'],
    standalone: true,
    imports: []
})
export class CustomSnackbarComponent implements OnInit {

  toastId: string = '';

  constructor (
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private coreService: CoreService
    ) { }

  ngOnInit() {

    this.toastId = this.coreService.toastId;
  }


  closeSnackbar(){
    this.data.snackBar.dismiss();
  }

}
